export const MOBILE_DRAWER_BREAKPOINT = 'md';
export const DRAWER_WIDTH = 280;
export const DRAWER_EXPANDED_WIDTH = 227;
export const DRAWER_COLLAPSED_WIDTH = 52;
export const FONT_URL =
    'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
